<div
    class="agpr-chartBlock agpr-chartBlock-dashboard agpr-contextMenu-parent"
    [id]="id + '_charBlock_dashboard'"
    role="group"
    [attr.aria-label]="chart?.metadata?.titleText + ' Chart. ' + ('Reports.chart.keyboardNavigationDescription' | localize)"
>
    <!-- chart-->
    <div
        *ngIf="!renderable"
        class='agpr-chartBlock-placeholder'
    >
        <div class="agpr-chartBlock-placeholder-topRow">
          <span
            class="fa agpr-chartBlock-placeholderIcon {{ block.type.icon }}"
            aria-hidden="true"
          ></span>
          <span class="agpr-chartBlock-placeholderLabel">{{ block.type.label | localize }}</span>
        </div>
        <div class="agpr-block-chartPlaceholder-body">
            <ng-template
                #customPlaceholderTemplate
                let-prefixText="prefixText"
                let-linkText="linkText"
                let-linkUrl="linkUrl"
            >
                <span>{{ prefixText }}<a target="_blank" href="{{ linkUrl }}">{{ linkText }}</a></span>
            </ng-template>
            <ng-container
                *ngIf="showExternalDataCustomPlaceholder"
            >
                <ng-container
                    *ngTemplateOutlet="customPlaceholderTemplate; context: externalDataCustomPlaceholderConfig;"
                >
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div
        *ngIf="actionable && !preview"
        class="agpr-chartBlock-dragHandle"
        role="button"
        [attr.aria-label]="'Reports.chart.dragHandle.ariaLabel' | localize"
        tabindex="0"
        (keydown)="dragKeydown($event)"
    >
        <span class="fa-kit fa-agpr-drag-drop"></span>
    </div>
    <!-- edit/delete icons -->
     @if (actionable) {
        <ul
            class="agpr-contextMenu top right"
            [id]="id + '_actionIcon'"
            role="menu"
        >
            <li role="menuitem">
                <agpr-button
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-duotone fa-trash-can"
                    tooltip="Dashboard.confirmDialog.deleteChart.button"
                    (click)="doAction($event, 'delete')"
                >
                </agpr-button>
            </li>
            <li role="menuitem">
                <agpr-button
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-duotone fa-pen"
                    tooltip="Dashboard.chartSettingsDialog.editChart"
                    (click)="doAction($event, 'edit')"
                >
                </agpr-button>
            </li>
        </ul>
     }
    <ng-container *ngIf="renderable">
        <div
            *ngIf="preview"
            class="agpr-chartBlock-watermark"
        >
            {{ 'Reports.chart.sampleData' | localize }}
        </div>

        <!-- the metadata only renders when the chart fails to get data, otherwise metadata is rendered via amcharts -->
        <div
            *ngIf="chart?.noDataError"
            class="agpr-chartBlockMetadata"
        >
            <div
                class="agpr-chartBlockMetadata-title"
            >
                {{ displayElement?.title }}
            </div>

            <div class="agpr-chartBlockMetadata-message">
                <agpr-message
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ 'Dashboard.chart.noTopicsToDisplay' | localize }}
                </agpr-message>
            </div>
            <div class="agpr-chartBlockMetadata-button">
                <agpr-button
                    (click)="navigateTo()"
                    [style]="buttonTypes.tertiary"
                    [label]="'Dashboard.chart.noTopicsToDisplayLink'"
                ></agpr-button>
            </div>
        </div>
        <div
            *ngIf="chart"
            class="agpr-chartBlock-chart"
        >
            <agpr-reports-chart
                [chart]="chart"
                (noData)="updateNoData($event)"
            ></agpr-reports-chart>
        </div>
    </ng-container>

    @if (actionable) {
        <div
            class="agpr-block-hoverBorder"
        >
        </div>
    }

    <!-- resize icons -->
    <div class="gridster-item-resize gridster-item-resize--right">
        <span
            class="gridster-item-icon--bottomRight fa-kit fa-agpr-resize-diagonal"
            role="img"
            [attr.aria-label]="'Dashboard.chart.resizeChart'"
        ></span>
    </div>
</div>

<div *ngIf="block.errors?.length > 0" class="agpr-blockError">
    <agpr-form-message
        *ngFor="let error of block.errors"
    >
        {{ error }}
    </agpr-form-message>
</div>
